import styled from 'styled-components'

export const Table = styled.div`
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.background.secondary};
`
